var _defs, _path, _circle, _path2, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeroBgElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 672 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M444.795 100.494l.766.643L56.031 565.36l-.765-.643z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102.399,
    cy: 510.278,
    r: 47.5,
    transform: "rotate(40 102.399 510.278)",
    stroke: "#7CA1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M227.205 511.506l-.766-.643L615.969 46.64l.765.643z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.345,
    cy: 120.08,
    r: 71.5,
    transform: "rotate(-140 554.345 120.08)",
    stroke: "#DEB06A"
  })));
}

var MemoSvgHeroBgElement = /*#__PURE__*/React.memo(SvgHeroBgElement);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjcyIiBoZWlnaHQ9IjYxMiIgdmlld0JveD0iMCAwIDY3MiA2MTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjQ0NC43OTUiIHk9IjEwMC40OTQiIHdpZHRoPSIxIiBoZWlnaHQ9IjYwNiIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgNDQ0Ljc5NSAxMDAuNDk0KSIgZmlsbD0iIzE0MTQxNCIvPgo8Y2lyY2xlIGN4PSIxMDIuMzk5IiBjeT0iNTEwLjI3OCIgcj0iNDcuNSIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgMTAyLjM5OSA1MTAuMjc4KSIgc3Ryb2tlPSIjN0NBMUExIi8+CjxyZWN0IHg9IjIyNy4yMDUiIHk9IjUxMS41MDYiIHdpZHRoPSIxIiBoZWlnaHQ9IjYwNiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE0MCAyMjcuMjA1IDUxMS41MDYpIiBmaWxsPSIjMTQxNDE0Ii8+CjxjaXJjbGUgY3g9IjU1NC4zNDUiIGN5PSIxMjAuMDgiIHI9IjcxLjUiIHRyYW5zZm9ybT0icm90YXRlKC0xNDAgNTU0LjM0NSAxMjAuMDgpIiBzdHJva2U9IiNERUIwNkEiLz4KPC9zdmc+Cg==";
export { MemoSvgHeroBgElement as ReactComponent };